/**
 * Active entry: functional activation page.
 * Legacy class: ./Activation.js
 */
import ActivationPage from "./ActivationPage";

export default ActivationPage;
